import HarpsApi from './harps-api';

export default {

  onload: () => {
    // console.log('js/feedback.js');
  }

}
